import { css } from "@styled-system/css";
import { flex } from "@styled-system/patterns";

export const wrapperClass = flex({
	gap: "8",
	marginBottom: "12",
});

export const dropdownClass = css({
	minWidth: "[350px]",
});
